import { styled } from 'canoe';

export const IFrameOverlay = styled.div`
  display: block;
  cursor: default;
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 10000;
  text-decoration: none;
`;
